/* tslint:disable */
/* eslint-disable */
/**
 * Role Requirements API
 * ap-southeast-2
 *
 * The version of the OpenAPI document: 1.0.dev
 * Contact: RoleReqs_DevTeam@seek.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, {
  type AxiosPromise,
  type AxiosInstance,
  type AxiosRequestConfig,
} from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
} from '../base';
// @ts-ignore
import { ProblemDetails } from '../models';
// @ts-ignore
import { Recommendations } from '../models';
// @ts-ignore
import { RecommendationsRequest } from '../models';
// @ts-ignore
import { SelectedRecommendationsRequest } from '../models';
/**
 * RecommendationsApi - axios parameter creator
 * @export
 */
export const RecommendationsApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @summary Create a question recommendation set
     * @param {string} questionnaireId The unique id for a questionnaire
     * @param {RecommendationsRequest} recommendationsRequest The recommendations request
     * @param {string} [ifMatch] The current version of this selected question set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    recommendationsCreate: async (
      questionnaireId: string,
      recommendationsRequest: RecommendationsRequest,
      ifMatch?: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'questionnaireId' is not null or undefined
      assertParamExists(
        'recommendationsCreate',
        'questionnaireId',
        questionnaireId,
      );
      // verify required parameter 'recommendationsRequest' is not null or undefined
      assertParamExists(
        'recommendationsCreate',
        'recommendationsRequest',
        recommendationsRequest,
      );
      const localVarPath =
        `/questionnaires/{questionnaireId}/recommendations`.replace(
          `{${'questionnaireId'}}`,
          encodeURIComponent(String(questionnaireId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication s2sauth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (ifMatch !== undefined && ifMatch !== null) {
        localVarHeaderParameter['If-Match'] = String(ifMatch);
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        recommendationsRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get a question recommendation set
     * @param {string} questionnaireId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    recommendationsGetRecommendations: async (
      questionnaireId: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'questionnaireId' is not null or undefined
      assertParamExists(
        'recommendationsGetRecommendations',
        'questionnaireId',
        questionnaireId,
      );
      const localVarPath =
        `/questionnaires/{questionnaireId}/recommendations`.replace(
          `{${'questionnaireId'}}`,
          encodeURIComponent(String(questionnaireId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication s2sauth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Persist selected questions from recommendations for later retrieval
     * @param {string} questionnaireId
     * @param {SelectedRecommendationsRequest} selectedRecommendationsRequest
     * @param {string} [ifMatch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    recommendationsPut: async (
      questionnaireId: string,
      selectedRecommendationsRequest: SelectedRecommendationsRequest,
      ifMatch?: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'questionnaireId' is not null or undefined
      assertParamExists(
        'recommendationsPut',
        'questionnaireId',
        questionnaireId,
      );
      // verify required parameter 'selectedRecommendationsRequest' is not null or undefined
      assertParamExists(
        'recommendationsPut',
        'selectedRecommendationsRequest',
        selectedRecommendationsRequest,
      );
      const localVarPath =
        `/questionnaires/{questionnaireId}/recommendations`.replace(
          `{${'questionnaireId'}}`,
          encodeURIComponent(String(questionnaireId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication s2sauth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (ifMatch !== undefined && ifMatch !== null) {
        localVarHeaderParameter['If-Match'] = String(ifMatch);
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        selectedRecommendationsRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RecommendationsApi - functional programming interface
 * @export
 */
export const RecommendationsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    RecommendationsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Create a question recommendation set
     * @param {string} questionnaireId The unique id for a questionnaire
     * @param {RecommendationsRequest} recommendationsRequest The recommendations request
     * @param {string} [ifMatch] The current version of this selected question set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async recommendationsCreate(
      questionnaireId: string,
      recommendationsRequest: RecommendationsRequest,
      ifMatch?: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Recommendations>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.recommendationsCreate(
          questionnaireId,
          recommendationsRequest,
          ifMatch,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     *
     * @summary Get a question recommendation set
     * @param {string} questionnaireId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async recommendationsGetRecommendations(
      questionnaireId: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Recommendations>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.recommendationsGetRecommendations(
          questionnaireId,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     *
     * @summary Persist selected questions from recommendations for later retrieval
     * @param {string} questionnaireId
     * @param {SelectedRecommendationsRequest} selectedRecommendationsRequest
     * @param {string} [ifMatch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async recommendationsPut(
      questionnaireId: string,
      selectedRecommendationsRequest: SelectedRecommendationsRequest,
      ifMatch?: string,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.recommendationsPut(
          questionnaireId,
          selectedRecommendationsRequest,
          ifMatch,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * RecommendationsApi - factory interface
 * @export
 */
export const RecommendationsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = RecommendationsApiFp(configuration);
  return {
    /**
     *
     * @summary Create a question recommendation set
     * @param {string} questionnaireId The unique id for a questionnaire
     * @param {RecommendationsRequest} recommendationsRequest The recommendations request
     * @param {string} [ifMatch] The current version of this selected question set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    recommendationsCreate(
      questionnaireId: string,
      recommendationsRequest: RecommendationsRequest,
      ifMatch?: string,
      options?: any,
    ): AxiosPromise<Recommendations> {
      return localVarFp
        .recommendationsCreate(
          questionnaireId,
          recommendationsRequest,
          ifMatch,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get a question recommendation set
     * @param {string} questionnaireId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    recommendationsGetRecommendations(
      questionnaireId: string,
      options?: any,
    ): AxiosPromise<Recommendations> {
      return localVarFp
        .recommendationsGetRecommendations(questionnaireId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Persist selected questions from recommendations for later retrieval
     * @param {string} questionnaireId
     * @param {SelectedRecommendationsRequest} selectedRecommendationsRequest
     * @param {string} [ifMatch]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    recommendationsPut(
      questionnaireId: string,
      selectedRecommendationsRequest: SelectedRecommendationsRequest,
      ifMatch?: string,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .recommendationsPut(
          questionnaireId,
          selectedRecommendationsRequest,
          ifMatch,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * RecommendationsApi - object-oriented interface
 * @export
 * @class RecommendationsApi
 * @extends {BaseAPI}
 */
export class RecommendationsApi extends BaseAPI {
  /**
   *
   * @summary Create a question recommendation set
   * @param {string} questionnaireId The unique id for a questionnaire
   * @param {RecommendationsRequest} recommendationsRequest The recommendations request
   * @param {string} [ifMatch] The current version of this selected question set
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RecommendationsApi
   */
  public recommendationsCreate(
    questionnaireId: string,
    recommendationsRequest: RecommendationsRequest,
    ifMatch?: string,
    options?: AxiosRequestConfig,
  ) {
    return RecommendationsApiFp(this.configuration)
      .recommendationsCreate(
        questionnaireId,
        recommendationsRequest,
        ifMatch,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get a question recommendation set
   * @param {string} questionnaireId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RecommendationsApi
   */
  public recommendationsGetRecommendations(
    questionnaireId: string,
    options?: AxiosRequestConfig,
  ) {
    return RecommendationsApiFp(this.configuration)
      .recommendationsGetRecommendations(questionnaireId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Persist selected questions from recommendations for later retrieval
   * @param {string} questionnaireId
   * @param {SelectedRecommendationsRequest} selectedRecommendationsRequest
   * @param {string} [ifMatch]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RecommendationsApi
   */
  public recommendationsPut(
    questionnaireId: string,
    selectedRecommendationsRequest: SelectedRecommendationsRequest,
    ifMatch?: string,
    options?: AxiosRequestConfig,
  ) {
    return RecommendationsApiFp(this.configuration)
      .recommendationsPut(
        questionnaireId,
        selectedRecommendationsRequest,
        ifMatch,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
